import React , {useEffect , useState , useRef  } from 'react'


import {  useLocation } from "react-router-dom";

import { ApiCallGet, ApiCallPost } from '../../ApiCall/ApiCall';

import LawyerDashData from './LawyerDashData';

import Footer from '../Footer/Footer';

function LawyerConsultaExpress() {

        const [registrado,setRegistrado] = useState(false)
        const [showRegistro,setShowRegistro] = useState( false )
        const [showData,setShowData] = useState( null ) ;
        const [state,setState] = useState( null )
        const [theId,setTheId] = useState( null )
    
        const location = useLocation();
    
        const  theInterval = useRef( null ) ;


            useEffect(() => {
        
                if ( theInterval.current !== null ) 
                {
                    clearInterval( theInterval.current )
                }
        
                console.log( "idLawyer = " , location.state)
        
                setState( location.state )
        
                setTheId( location.state.id )
        
                if ( registrado === false )
                {
                    return ; // El abogado no esta registrado para consulta express
                }
        
                theInterval.current = setInterval( checalo , 5000); // Revisamos cada 5 segundos
        
        
                function checalo()
                {
        
                    console.log( "poolagenda " , registrado )
        
        
                    if ( registrado )
                    {
        
                        console.log( "poolagenda")
        
                        ApiCallGet('/poolagenda')
                        .then((response) => {
        
                            console.log( "poolagenda = " , response )
        
                            if ( response.length === 0 )
                            {
                                setShowRegistro( false ) // Aqui borramos la info del registro
                                return ; // No encontro elementos
                            }
        
        
        
                            setShowData( response[0] ) // Aqui tenemos los datos del primer registro
        
                            console.log( "Nos vamos a show registro")
        
                            setShowRegistro( true )
        
        
                        })
                        .catch((err)=> {
        
                            console.log( "No llego un error =====>>>")
        
                            console.log( err ) // Se detecto un error en la consulta
        
                        })
        
                        
                    }
                    else{
        
                        console.log( "No esta registrado!!!")
        
                    }
                }
        
         
        
        
        
            },[registrado])

    function onConferencia()
    {
        // Debemos de chacar si ya se encuentra en conferencia , pq si ya esta le debsmos enviar un mensaje


        ApiCallPost( "/lawyer_set_notified" , { id : state.id , status : 1 } )
        .then( (res) => {

            console.log( res )

            if ( res.status === 0 )
            {
                window.open( "https://lawyer.legaltek.digital/?name=" + state.name , '_blank')

                return ;
            }


            if ( res.status === 1 )
            {
                alert( "El cliente esta siendo atendido por otro abogado")
            }

        })
        .catch( (err) => {

            console.log( err )

        })




        window.open( "https://lawyer.legaltek.digital/?name=" + state.name , '_blank')
    }

    function onRegistrar()
    {
        console.log( "Registrando " , state )

        ApiCallPost( "/lawyer_set_agenda" , { id : state.id , status : !registrado } )
        .then( (res) => {

            console.log( "/lawyer_set_agenda" ,  " Registrado = " , registrado  )

            if ( res.status === 0 )
            {
                setRegistrado( !registrado )
            }

        })
        .catch( (err) => {

            console.log( err )

        })

        
    }

    useEffect(() => {

        console.log( "LawyerDash " + location.state?.name + " logg_expres " +  location.state?.logg_express )

        setRegistrado( location.state?.logg_express )


    },[])


        
    

  return (
    <div className='box-1 backemployer-2 centersearch w-100 m-1 align-items-center' style={{height:'50vh' , marginTop :'5px'}} >
    {/*<div>*/}    <div className='d-flex flex-column  box-1 backemployer-2 mb-0 form-2 w-100 mt-0' style={{padding :'0px'}}>

    <h4 className=' mt-5'>
         Configuración Consulta Express
    </h4>

    <div >
    
        <h4>
            Bienvenido {state?.name}
        </h4>
    
    </div>

    <div className='row  mt-5 ms-5'>

        <div className='col-sm-4'>

            <p>Estado de consulta express</p>

        </div>

        <div className='col-sm-4 border-0 ' style={{border : '2px solid black' , height :'200px'}}>

            
                <button type="button" className={registrado ? "estilo_boton_selected" :"estilo_boton"} 
                    onClick={onRegistrar}>{registrado? "Registrado" : "Registrar"}</button>
        
        </div>

        {
            showRegistro && registrado && showData !== null && (
                <>

                    <div className='col-sm-4 border-0 ' style={{border : '2px solid black' , height :'200px'}}>

            
                        <button type="button" className={registrado ? "estilo_boton_selected" :"estilo_boton"} 
                            onClick={onConferencia}>Conferencia</button>
        
                    </div>       
        
                    <LawyerDashData data={showData}/>

                </>
            )

        }

    </div>



</div>
{/*</div>*/}
</div>
  )
}

export default LawyerConsultaExpress